import axios from "axios";
import apiClient from "./BaseService";

import { EMPLOYEE_URL, URL } from "../config";
import { store } from "../_app";

interface UserLoginProps {
  username: string;
  password: string;
}

interface EmployeeLoginProps {
  email: string;
  password: string;
}

const _userLogin = async (data: UserLoginProps) =>
  axios.post(URL.LOGIN, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const _refreshToken = async () =>
  axios.post(URL.REFRESH_TOKEN, {
    refresh: store.getState().user.refresh,
  });

const _logoutRegister = async () =>
  axios.patch(URL.LOGOUT_REGISTER + `?user_id=${store.getState().user.id}`);

const _forgotPassword = async (email: string) =>
  axios.post(
    URL.PASSWORD_RESET,
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const _validateToken = async (token: string) => {
  let res = axios.get(URL.VALIDATE_TOKEN + token, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
};

const _changePassword = async (token: string, password: string) =>
  axios.post(
    URL.CHANGE_PASSWORD,
    { token, password },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const _setPassword = async (data: any) =>
  axios.post(URL.PASSWORD_SET, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const _changePasswordUser = async (data: any) =>
  apiClient.patch(URL.USER_CHANGE_PASSWORD, data);

const _loginAddRequest = async(data:any) => apiClient.post(URL.GET_EXTERNAL_COMPANY_LISTING,data);
   
const _companyAddRequest = async(query:any) => apiClient.get(URL.GET_COMPANY_NAME +`${query}` )



// <------------- Employee Auth Service ------------->

const _employeeLogin = async (data: EmployeeLoginProps) =>
axios.post(EMPLOYEE_URL.LOGIN, data, {
  headers: {
    "Content-Type": "application/json",
  },
});

const _employeeRefreshToken = async () =>
  axios.post(EMPLOYEE_URL.REFRESH_TOKEN, {
      refresh: store.getState().user.refresh,
  });


  const _getEmployeePermission = async (companyId: any) =>
    apiClient.get(`${EMPLOYEE_URL.GET_EMPLOYEE_PERMISSION}${companyId}`);

export const AuthService = {
  _userLogin,
  _refreshToken,
  _forgotPassword,
  _changePassword,
  _changePasswordUser,
  _validateToken,
  _setPassword,
  _logoutRegister,
  _loginAddRequest,
  _companyAddRequest,
  _employeeLogin,
  _employeeRefreshToken,
  _getEmployeePermission,
};
